import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/Choose a specialist.webm")